import React from 'react';
import { Modal, Button } from 'components';
import { SchedulePicker } from './SchedulePicker';
import { useSchedulePickerController } from '../application/SchedulePickerController';
import { ScheduleDate } from '../entities/ScheduleDate';
import * as S from './styles';

interface Props {
  isOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  onScheduleMessage: (props: { sendAt: Date }) => void;
}

export const SchedulePickerModal: React.FC<Props> = ({ isOpen, setIsModalOpen, onScheduleMessage }) => {
  const { selected, isValid, setSelected } = useSchedulePickerController(new Date());
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsModalOpen(false)}
      title="Escolher data e hora"
    >
      <SchedulePicker value={selected.getRaw()} onChange={(date) => setSelected(new ScheduleDate(date))} />
      <S.ButtonsContainer>
        <Button variant="ghost" onClick={() => setIsModalOpen(false)}>
          Cancelar
        </Button>
        <Button
          onClick={() => {
            onScheduleMessage({ sendAt: selected.getRaw() });
            setIsModalOpen(false);
          }}
          disabled={!isValid}
        >
          Agendar mensagem
        </Button>
      </S.ButtonsContainer>
    </Modal>
  );
};
